export default __webpack_public_path__ + "static/media/twitter.77e2c87f.svg";